module.exports = __webpack_public_path__ + "img/45.17142fed.jpg";